import { useEffect } from "react";

import { Modal, Button } from "react-bootstrap";
import "./ProfileSucces.css";
import WhiteButton from "./../../common_button/WhiteButton";
import Succes_lottie from "./../../../animation/succes_lottie/Succes_lottie";
import { useNavigate } from "react-router-dom";

export default function SuccessModal({ show, handleClose }) {
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/profile");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdropClassName="success-backdrop"
      contentClassName="success-modal-content"
    >
      <div className="success-wrapper">
        <div className="success-box">
          <Succes_lottie />
          <div className="contain-wrapper">
            <h4>Profile Updated Successfully!</h4>
            <p>
              Your changes have been saved. Keep your details updated for smooth
              withdrawals.
            </p>
          </div>
        </div>

        <div className="button-wrapper">
          <WhiteButton
            title={"Back To Profile"}
            bg="#010E1E"
            color="#f35f37"
            hoverColor="#f35f37"
            hoverBg={"#010E1E"}
            onClick={() => navigate("/profile")}
          />
        </div>
      </div>
    </Modal>
  );
}
